const REFERER_REF_NAME = "referer";

export function setReferer(referer: string) {
  localStorage.setItem(REFERER_REF_NAME, referer);
}

export function getReferer() {
  return localStorage.getItem(REFERER_REF_NAME);
}
